import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange, SimpleChanges } from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { TimeUtilsService } from 'map-wald';

/*
  <div class="input-group">
    <input class="form-control"
           type="text"
           placeholder="yyyy-mm-dd"
           [(ngModel)]="selectedDate"
           (ngModelChange)="dateSelected($event)"
           [navigation]="'select'"
           [displayMonths]="1"
           [maxDate]="maxDate"
           [minDate]="minDate"
           ngbDatepicker
           #d="ngbDatepicker"/>
    <button class="btn btn-outline-secondary fa fa-calendar " (click)="d.toggle()" type="button"></button>
  </div>
*/

@Component({
  selector: 'date-time-picker',
  template: `
  <p>Date</p>
    <date-selection [dates]="uniqueDates"
                    [(date)]="date"
                    (dateChange)="dateSelected($event)"
                    [timestep]="'daily'"></date-selection>
    <div class="input-group">
      <p>Time of day</p>
      <select class="form-control" [(ngModel)]="dateTime" (ngModelChange)="setDate($event)">
        <option *ngFor="let time of timeOptions" [ngValue]="time">{{time|date:'shortTime'}}</option>
      </select>
    </div>`,
  styles: [

  ]
})
export class DateTimePickerComponent implements OnInit, OnChanges {
  @Input() dates:any[] = [];
  uniqueDates:Date[];
  dateTime:Date;
  @Input() date:Date;
  @Output() dateChange:EventEmitter<Date> = new EventEmitter<Date>();

  selectedDate:NgbDateStruct;
  minDate:NgbDateStruct;
  maxDate:NgbDateStruct;
  dateIndex: {
    [key:number]:{
      [key:number]:{
        [key:number]:Date[]
      }
    }
  } = {}
  timeOptions:Date[] = [];

  constructor(private timeUtils:TimeUtilsService) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    // console.log(this.dates);
    if(this.dateArrayChanged(changes.dates)){
      this.indexDates();
    }
  }

  dateArrayChanged(chg:SimpleChange){
    if(!chg){
      return false;
    }
    if(chg.currentValue?.length !== chg.previousValue?.length){
      return true;
    }
    for(let i = 0; i < chg.currentValue.length; i++){
      if(chg.currentValue[i].label){
        if(chg.currentValue[i].label !== chg.previousValue[i].label){
          return true;
        }
      } else if(chg.currentValue[i] !== chg.previousValue[i]){
        return true;
      }
    }
    return false;
  }

  indexDates() {
    this.uniqueDates = Array.from(new Set(this.dates.map(date => {
      let d = new Date(date?.value || date);
      d.setHours(0, 0, 0, 0);
      return d.getTime();
    }))).map(time => new Date(time))

    this.minDate = this.timeUtils.convertDate(this.uniqueDates[0]);
    this.maxDate = this.timeUtils.convertDate(this.uniqueDates[this.uniqueDates.length-1]);
    console.log(this.minDate, this.maxDate);
    this.dates.forEach(date => {
      let dateObj = new Date(date?.value || date);
      let y = dateObj.getFullYear();
      let m = dateObj.getMonth()+1;
      let day = dateObj.getDate();
      if (!this.dateIndex[y]) {
        this.dateIndex[y] = {};
      }
      if (!this.dateIndex[y][m]) {
        this.dateIndex[y][m] = {};
      }
      if (!this.dateIndex[y][m][day]) {
        this.dateIndex[y][m][day] = [];
      }
      this.dateIndex[y][m][day].push(dateObj);
    });
    let initialDate:Date = this.dates[this.dates.length-1];
    initialDate = (initialDate as any)?.value || initialDate;
    this.selectedDate = this.timeUtils.convertDate(initialDate);
    this.timeOptions = this.dateIndex[this.selectedDate.year]?.[this.selectedDate.month]?.[this.selectedDate.day];
    this.setDate(initialDate);
  }

  dateSelected(date: Date) {
    console.log(date);
    console.log(this.timeOptions);
    const y = date.getFullYear();
    const m = date.getMonth()+1;
    const d = date.getDate();
    this.timeOptions = this.dateIndex[y]?.[m]?.[d];
    if(this.timeOptions?.length){
      this.setDate(this.timeOptions[this.timeOptions.length-1]);
    }
  }

  // dateSelected(date: NgbDateStruct) {
  //   console.log(date);
  //   console.log(this.timeOptions);
  //   this.timeOptions = this.dateIndex[date.year]?.[date.month]?.[date.day];
  //   this.setDate(this.timeOptions[this.timeOptions.length-1]);
  // }

  setDate(date: Date) {
    this.dateTime = date;
    console.log(this.selectedDate);
    this.dateChange.emit(this.dateTime);
  }
}

// For a given date, select relevant timestamps...

